import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './components/pages/about/about.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { BlogComponent } from './components/pages/blog/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { ServicesComponent } from './components/pages/services/services/services.component';
import { ServiceDetailsComponent } from './components/pages/services/service-details/service-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
// import { HomeOneComponent } from './components/pages/home-one/home-one.component';
// import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
// import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
// import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { WhyUsComponent } from './components/pages/why-us/why-us.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { InBoundComponent } from './components/pages/inBound/inBound.component';
import { BulkSmsSenderComponent } from './components/pages/bulk-sms-sender/bulk-sms-sender.component';
import { OutBoundComponent } from './components/pages/outBound/outBound.component';
import { BulkWhatsAppComponent } from './components/pages/bulk-whats-app/bulk-whats-app.component';
import { EducationComponent } from './components/pages/education/education.component';
import { HealthcareComponent } from './components/pages/healthcare/healthcare.component';
import { EcommerceComponent } from './components/pages/ecommerce/ecommerce.component';
import { RetailComponent } from './components/pages/retail/retail.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { HomeComponent } from './components/pages/home/home.component';
import { PlansComponent } from './components/pages/plans/plans.component';
import { PromotionalCallsComponent } from './components/pages/promotional-calls/promotional-calls.component';
import { UtilitiesComponent } from './components/pages/utilities/utilities.component';
import { TourAndTravelsComponent } from './components/pages/tour-and-travels/tour-and-travels.component';
import { BookDemoComponent } from './components/pages/book-demo/book-demo.component';
import{TermsComponent} from './components/pages/terms/terms.component';
import{CookiesPolicyComponent} from './components/pages/cookies-policy/cookies-policy.component';
import {RefundPolicyComponent} from './components/pages/refund-policy/refund-policy.component';
import { PartnersPageComponent} from './components/pages/partners-page/partners-page.component';
import{EmailComponent} from './components/pages/email/email.component';
import{WhatsappMetaComponent} from './components/pages/whatsapp-meta/whatsapp-meta.component';
import{RcsComponent} from './components/pages/rcs/rcs.component';
import{IvrComponent} from './components/pages/ivr/ivr.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';


const routes: Routes = [
    {path: '', component: HomeComponent},    
    {path: 'home', component: HomeComponent},    
    // {path: 'home-one', component: HomeOneComponent},
    // {path: 'home-two', component: HomeTwoComponent},
    // {path: 'home-three', component: HomeThreeComponent},
    // {path: 'home-four', component: HomeFourComponent},
    {path: 'about', component: AboutComponent},
    {path: 'features', component: FeaturesComponent},
    {path: 'team', component: TeamComponent},
    {path: 'services', component: ServicesComponent},
    {path: 'service-details', component: ServiceDetailsComponent},
    {path: 'blog', component: BlogComponent},
    {path: 'blog-details', component: BlogDetailsComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'coming-soon', component: ComingSoonComponent},
    {path: 'pricing', component: PricingComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'login', component: LoginComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'why-us', component: WhyUsComponent},
    {path: 'about-us', component: AboutUsComponent},
    {path: 'careers', component: CareersComponent},
    {path: 'inBound', component: InBoundComponent},
    {path: 'bulk-sms-sender', component: BulkSmsSenderComponent},
    {path: 'book-demo', component: BookDemoComponent},
     {path: 'outBound', component: OutBoundComponent},
    {path: 'bulkWhatsApp', component: BulkWhatsAppComponent},
    {path: 'promotional-calls', component: PromotionalCallsComponent},
    {path: 'education', component: EducationComponent},
    {path: 'healthcare', component: HealthcareComponent},
    {path: 'ecommerce', component: EcommerceComponent},
    {path: 'retail', component: RetailComponent},
    {path: 'tour-and-travels' , component: TourAndTravelsComponent},
    {path: 'Utilities', component: UtilitiesComponent},
    {path: 'privacy', component: PrivacyComponent},
    {path: 'plans', component: PlansComponent},
    {path: 'terms', component: TermsComponent},
    {path: 'refund-policy', component: RefundPolicyComponent},
    {path: 'partners', component: PartnersPageComponent},
    {path: 'cookies', component: CookiesPolicyComponent},
    {path: 'email' , component:EmailComponent},
    {path: 'whatsapp-meta' , component:WhatsappMetaComponent},
    {path: 'rcs' , component:RcsComponent},
    {path: 'ivr' , component:IvrComponent},

    
    // Here add new pages component

    // {path: '**', component: NotFoundComponent} // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true ,enableTracing:true})],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})
export class AppRoutingModule {

  
 }
